import type { Id } from '@hq/utils';
import { toQuery, type HttpClient } from '../client';
import type {
  PurchaseCreateRequest,
  PurchaseDetail,
  PurchaseListQuery,
  PurchaseReceiveRequest,
  PurchaseReceiveResult,
  PurchaseRow,
  RequireCreateRequest,
  RequireDetail,
  RequireListQuery,
  RequireRow
} from '../types/procurement';
import type { PageResult } from '../types/result';

/**
 * 请购（QG）与采购（CG）：
 * 建请购 → 生成采购单 → 下达/接单 → 到货生成入库单（WAIT_CHECK，再走入库确认写库存）。
 */
export function createProcurementApi(http: HttpClient) {
  return {
    requires: {
      list(query: RequireListQuery = {}): Promise<PageResult<RequireRow>> {
        return http.request<PageResult<RequireRow>>({ path: '/wl/require', query: toQuery(query) });
      },
      detail(id: Id): Promise<RequireDetail> {
        return http.request<RequireDetail>({ path: `/wl/require/${id}` });
      },
      create(body: RequireCreateRequest): Promise<RequireDetail> {
        return http.request<RequireDetail>({ path: '/wl/require', method: 'POST', body });
      }
    },

    purchases: {
      list(query: PurchaseListQuery = {}): Promise<PageResult<PurchaseRow>> {
        return http.request<PageResult<PurchaseRow>>({ path: '/wl/purchase', query: toQuery(query) });
      },
      detail(id: Id): Promise<PurchaseDetail> {
        return http.request<PurchaseDetail>({ path: `/wl/purchase/${id}` });
      },
      create(body: PurchaseCreateRequest): Promise<PurchaseDetail> {
        return http.request<PurchaseDetail>({ path: '/wl/purchase', method: 'POST', body });
      },
      /** 供应商接单。 */
      ack(id: Id): Promise<PurchaseDetail> {
        return http.request<PurchaseDetail>({ path: `/wl/purchase/${id}/ack`, method: 'POST' });
      },
      /** 到货：生成入库单并回写收货数量。 */
      receive(id: Id, body: PurchaseReceiveRequest): Promise<PurchaseReceiveResult> {
        return http.request<PurchaseReceiveResult>({ path: `/wl/purchase/${id}/receive`, method: 'POST', body });
      }
    }
  };
}

export type ProcurementApi = ReturnType<typeof createProcurementApi>;
